/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Test } from '../models/Test';
import type { TestAttempt } from '../models/TestAttempt';
import type { TestAttemptInput } from '../models/TestAttemptInput';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class TestsService {
    /**
     * Получить список тестов
     * @returns any Список тестов
     * @throws ApiError
     */
    public static getTests(): CancelablePromise<{
        items?: Array<Test>;
    }> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/tests',
        });
    }
    /**
     * Создать новый тест
     * @param requestBody Объект теста для создания
     * @returns Test Тест успешно создан
     * @throws ApiError
     */
    public static addTest(
        requestBody: Test,
    ): CancelablePromise<Test> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/tests',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Получить тест по ID
     * @param id UUID теста
     * @returns Test Информация о тесте
     * @throws ApiError
     */
    public static getTest(
        id: string,
    ): CancelablePromise<Test> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/tests/{id}',
            path: {
                'id': id,
            },
            errors: {
                404: `Тест не найден`,
            },
        });
    }
    /**
     * Обновить тест по ID
     * @param id UUID теста
     * @param requestBody Обновлённый объект теста
     * @returns Test Тест успешно обновлён
     * @throws ApiError
     */
    public static updateTest(
        id: string,
        requestBody: Test,
    ): CancelablePromise<Test> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/tests/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                404: `Тест не найден`,
            },
        });
    }
    /**
     * Удалить тест по ID
     * @param id UUID теста
     * @returns void
     * @throws ApiError
     */
    public static deleteTest(
        id: string,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/tests/{id}',
            path: {
                'id': id,
            },
        });
    }
    /**
     * Создать новую запись попытки теста
     * @param requestBody
     * @returns TestAttempt Запись успешно создана
     * @throws ApiError
     */
    public static createTestAttempt(
        requestBody: TestAttemptInput,
    ): CancelablePromise<TestAttempt> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/test-attempts',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Неверный запрос`,
            },
        });
    }
    /**
     * Получить записи попыток теста по test_id
     * @param testId Идентификатор теста для фильтрации записей попыток
     * @returns any Список найденных записей
     * @throws ApiError
     */
    public static getTestAttempts(
        testId: string,
    ): CancelablePromise<{
        items?: Array<TestAttempt>;
    }> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/test-attempts',
            query: {
                'test_id': testId,
            },
            errors: {
                404: `Записи не найдены`,
            },
        });
    }
}
